import type { CityConfig } from "../city-template/types";

export const rollaMOConfig: CityConfig = {
  city: "Rolla",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "rolla-mo",
  route: "/rolla-mo",
  title: "Emergency Passport Rolla, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rolla, MO — as fast as 24 hours. Serving Phelps County and the Missouri S&T community. A+ BBB rated registered State Dept. courier serving Rolla, St. James, Fort Leonard Wood, and south-central Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Rolla, MO",
  heroSubtitle: "Missouri S&T engineering student heading to a co-op in Germany next week? Route 66 road trip turns international with passport issues? Fort Leonard Wood family needing urgent travel documents? We help Rolla residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Rolla%20Missouri%20Phelps%20County%20Missouri%20University%20of%20Science%20and%20Technology%20campus%20engineering%20college%20town%20Ozark%20landscape%20Stonehenge%20replica%20landmark%20historic%20Route%2066%20corridor%20academic%20buildings%20red%20brick%20campus%20structures%20rolling%20green%20hills%20soft%20morning%20light%20professional%20drone%20photography%20Heartland%20education%20and%20innovation%20hub&width=1800&height=700&seq=rolla-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Rolla Missouri S&T campus and Route 66 corridor in the Ozark landscape at morning light",
  geoPosition: "37.9485;-91.7715",
  geoPlacename: "Rolla, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 425 miles northeast of Rolla via I-44/I-55",
  },
  nearbyCitiesZips: [
    { name: "Rolla", zips: "65401, 65402" },
    { name: "St. James", zips: "65559" },
    { name: "Newburg", zips: "65550" },
    { name: "Doolittle", zips: "65453" },
    { name: "St. Robert", zips: "65584" },
    { name: "Waynesville", zips: "65583" },
    { name: "Salem", zips: "65560" },
    { name: "Cuba", zips: "65453" },
    { name: "Vienna", zips: "65582" },
    { name: "Licking", zips: "65542" },
    { name: "Steelville", zips: "65565" },
    { name: "Bourbon", zips: "65441" },
    { name: "Sullivan", zips: "63080" },
    { name: "Owensville", zips: "65066" },
    { name: "Houston", zips: "65483" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Phelps County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "S&T & Route 66 Hub", desc: "Serving Missouri S&T, Fort Leonard Wood, and south-central Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/st-louis" },
    { name: "Fast passport renewal in Columbia, MO", route: "/columbia-mo" },
    { name: "Emergency passport help in Jefferson City, MO", route: "/jefferson-city" },
    { name: "Urgent passport services in Springfield, MO", route: "/springfield-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Cape Girardeau, MO", route: "/cape-girardeau" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Rolla remotely via secure courier. We do not have a walk-in office in Rolla — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Phelps County, Missouri S&T students, and the Fort Leonard Wood community.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Phelps County including Rolla, St. James, Newburg, and surrounding south-central Missouri communities",
  serviceAreaIntro: "From the Missouri S&T campus and the historic Route 66 corridor through Rolla to the Mark Twain National Forest trails and the nearby Fort Leonard Wood military installation, from the wine country of St. James to the Ozark springs of Maramec — Fast Passport Center serves the entire Phelps County and south-central Missouri region. We regularly help Missouri S&T students, Fort Leonard Wood families, and Route 66 travelers get their passports fast without the 5.5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Rolla neighborhoods and the surrounding Phelps County area including St. James, Newburg, Doolittle, Waynesville, and Salem. If you are anywhere in Phelps County, Pulaski County, or south-central Missouri, we have you covered.",
  howItWorksIntro: "Most Rolla travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Rolla travelers often face a 5.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Rolla and Phelps County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Rolla? Here are the most common ones we hear from Phelps County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Rolla travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Priya M.",
      location: "Rolla, MO",
      rating: 5,
      text: "Missouri S&T mechanical engineering co-op in Munich started Monday — realized Wednesday my passport was expired. Fast Passport Center got it done in 26 hours. From the S&T campus to Oktoberfest. Absolutely legendary service for students!",
      service: "Passport Renewal",
    },
    {
      name: "Sgt. Michael D.",
      location: "Fort Leonard Wood, MO",
      rating: 5,
      text: "Military deployment orders came fast. Fast Passport Center handled my expedited documents in 30 hours. The dedicated agent understood Defense Department timelines. Outstanding for Fort Leonard Wood and Pulaski County service members.",
      service: "Emergency Passport",
    },
    {
      name: "Karen T.",
      location: "St. James, MO",
      rating: 5,
      text: "Our family had a reunion in Costa Rica. Both kids needed passport cards fast. Fast Passport Center guided us through the child passport process — all done in 4 days. Phelps County parents, this is the only service you need!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "rolla-1",
      name: "Rolla Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 W 8th St",
      city: "Rolla",
      state: "MO",
      zip: "65401",
      phone: "(573) 364-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Rolla",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Rolla facility on 8th Street. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "rolla-2",
      name: "Phelps County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "200 N Main St",
      city: "Rolla",
      state: "MO",
      zip: "65401",
      phone: "(573) 458-6110",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Rolla Courthouse",
      website: "https://www.phelpscounty.org",
      websiteLabel: "Phelps County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "rolla-3",
      name: "St. James Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Jefferson St",
      city: "St. James",
      state: "MO",
      zip: "65559",
      phone: "(573) 265-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles northeast of Rolla",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves St. James wine country area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "rolla-4",
      name: "Waynesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 North St",
      city: "Waynesville",
      state: "MO",
      zip: "65583",
      phone: "(573) 774-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southwest of Rolla",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Waynesville and Fort Leonard Wood area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "rolla-5",
      name: "Salem Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "303 N Main St",
      city: "Salem",
      state: "MO",
      zip: "65560",
      phone: "(573) 729-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southeast of Rolla",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Dent County area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Rolla photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Phelps County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Rolla applicants including S&T students show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many S&T faculty families and Phelps County residents at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Rolla travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Rolla." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rolla address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Rolla before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Rolla for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Rolla?", a: "Fast Passport Center offers fast passport renewal in Rolla in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Rolla?", a: "The nearest regional passport agency to Rolla is the Chicago Passport Agency, approximately 425 miles northeast via I-44/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Rolla without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Rolla?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5.5 hours from Rolla — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Phelps County and Missouri S&T community residents." },
    { q: "Do you serve Missouri S&T students and Fort Leonard Wood?", a: "Absolutely. Fast Passport Center proudly serves Missouri S&T students needing urgent passports for study abroad, co-ops, and international conferences. We also serve Fort Leonard Wood military families in the Pulaski County area with expedited processing." },
    { q: "Can I expedite a child passport in Rolla?", a: "Yes. Fast Passport Center expedites child passports in Rolla for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Phelps County and S&T families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Rolla with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Rolla", address: "500 S Bishop Ave, Rolla, MO 65401", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Rolla", address: "1000 N Bishop Ave, Rolla, MO 65401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — St. Robert", address: "330 Marshall Dr, St. Robert, MO 65584", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — St. Robert", address: "185 Saint Robert Blvd, St. Robert, MO 65584", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Rolla License Office",
      address: "1050 N Bishop Ave, Rolla, MO 65401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Rolla residents and Missouri S&T students.",
      featured: true,
    },
    {
      name: "Missouri DOR — St. Robert License Office",
      address: "393 Old Rte 66, St. Robert, MO 65584",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Fort Leonard Wood area and Pulaski County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Salem License Office",
      address: "202 N Washington St, Salem, MO 65560",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Dent County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "100 miles northeast of Rolla",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 1 hour 40 minutes from Rolla via I-44.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "TBN",
      name: "Waynesville-St. Robert Regional Airport (Forney Field)",
      distance: "25 miles southwest of Rolla",
      address: "501 Iowa Ave, Fort Leonard Wood, MO 65473",
      note: "Regional airport serving Fort Leonard Wood and Pulaski County. About 35 minutes from Rolla via I-44.",
      flightUrl: "https://www.flytbn.com/",
      flightLabel: "TBN Airport",
      featured: false,
    },
    {
      code: "SGF",
      name: "Springfield-Branson National Airport",
      distance: "120 miles southwest of Rolla",
      address: "2300 N Airport Blvd, Springfield, MO 65802",
      note: "Major airport for southwest Missouri. About 2 hours from Rolla via I-44.",
      flightUrl: "https://www.flyspringfield.com/",
      flightLabel: "SGF Airport",
      featured: false,
    },
  ],
};